import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'vant/lib/index.css'; // 引入vant样式
import router from './router/index'
import store from './store';
import App from './App.vue'
import vant from 'vant'
import 'vant/lib/index.css'
import SvgIcon from '@/components/SvgIcon.vue'
import '@/icons' // 引入 SVG 图标
import { globalMixin } from '@/mixins/global'

const app = createApp(App);
app.component('SvgIcon', SvgIcon)
app.use(ElementPlus);
app.use(store);
app.use(router);
app.use(vant);

// 添加全局 mixin
app.mixin(globalMixin)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mount('#app');